import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const MarkerDotSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 13 13",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <circle
        xmlns="http://www.w3.org/2000/svg"
        cx="6.54301"
        cy="6.86137"
        r="6.08012"
        fill="white"
      />
      <circle
        xmlns="http://www.w3.org/2000/svg"
        cx="6.54301"
        cy="6.86137"
        r="4.50687"
        fill="#A5C9FF"
      />
    </svg>
  );
};

export { MarkerDotSvg };
